// HelpDesk Brand Color Palette
// Primary text/nav: #071136, Accent: #FF4667
export const colors = {
  light: {
    primary: '#000000',        // Deep navy for headings, nav, key text
    secondary: '#006600',      // Brand green for CTAs and highlights
    background: '#F8FCFB',     // Soft teal-tinted background as on LandingPage
    surface: '#FFFFFF',        // White surfaces/cards
    text: '#000000',           // Main text color
    secondaryText: '#4A5B63',  // Muted body text
    border: '#E5EFF3',         // Subtle light border
    success: '#16A34A',        // Green success
    error: '#DC2626',          // Red error
    warning: '#F59E0B',        // Amber warning
    info: '#071136',           // Info aligned with primary
    // Brand Color Variants
    tealVariant1: '#006600',   // Primary green variant
    tealVariant2: '#BB0000',   // Supporting red variant
    orangeLight: '#FFE7E0',    // Soft tint used in LandingPage badges
  },
  dark: {
    primary: '#FF4667',        // Accent pops on dark background
    secondary: '#FFFFFF',      // Light neutral secondary
    background: '#071136',     // Deep navy background
    surface: '#101426',        // Dark card surface
    text: '#F9FAFB',           // Light text on dark
    secondaryText: '#9CA3AF',  // Muted light text
    border: '#27303F',         // Dark border
    success: '#22C55E',        // Green success (dark mode)
    error: '#F97373',          // Lighter red for dark
    warning: '#FACC15',        // Brighter amber for dark
    info: '#FF4667',           // Accent as info color
  }
};

// CSS custom properties for dynamic theme switching
// OUK Brand Colors: Primary (#307A91), Secondary (#FE7F50)
export const generateCSSVariables = (theme) => {
  const themeColors = colors[theme];
  
  return {
    '--color-primary': themeColors.primary,
    '--color-secondary': themeColors.secondary,
    '--color-background': themeColors.background,
    '--color-surface': themeColors.surface,
    '--color-text': themeColors.text,
    '--color-secondary-text': themeColors.secondaryText,
    '--color-border': themeColors.border,
    '--color-success': themeColors.success,
    '--color-error': themeColors.error,
    '--color-warning': themeColors.warning,
    '--color-info': themeColors.info,
    // OUK Brand Variants
    '--color-teal-variant1': themeColors.tealVariant1 || themeColors.primary,
    '--color-teal-variant2': themeColors.tealVariant2 || themeColors.primary,
    '--color-orange-light': themeColors.orangeLight || themeColors.secondary,
  };
};

// Color contrast utilities for accessibility
export const getContrastColor = (backgroundColor, theme) => {
  // Simple contrast calculation - in a real implementation, you'd use a proper contrast library
  const isLight = theme === 'light';
  return isLight ? colors.light.text : colors.dark.text;
};

// Theme validation
export const validateTheme = (theme) => {
  return theme === 'light' || theme === 'dark';
};

export default colors;
